import Typography from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/Typography';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';
import type { TextItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/textItemAttributes';

interface HeadlineProps
  extends Omit<ComponentSettingsTab<HeroItemAttributes>, 'item'> {
  item: DocumentItem<TextItemAttributes>;
}

const Headline = ({
  defaultAttributes,
  permissions: { can } = { can: {}, flags: {} },
  item,
  onChange,
}: HeadlineProps) => {
  const settingProps = { defaultAttributes, item, onChange };

  return (
    <Typography
      includeTextBackground={can?.updateTextBackground}
      {...settingProps}
    />
  );
};

export default Headline;
